import { MeasureDateRange } from "../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../api/types/svTypes.ts";
import { DimensionFieldType } from "../../../../../../api/types/svTypes.ts";
import { isReferenceDateField } from "../../components/builder/common/utilities/isReferenceDateField";
import { isAccountBasedField } from "../../utilities/DimensionNames";

export const calculateShowNonZeroBalanceAccounts = (fields: ReportField[]) => {
  const referenceDateField = fields.find((field) => isReferenceDateField(field.meta));
  if (!referenceDateField || referenceDateField.config.grouping) {
    return false;
  }

  const hasAccountBasedFields = fields.some((field) => isAccountBasedField(field.meta.name));
  if (!hasAccountBasedFields) {
    return false;
  }

  const isThereAnyMeasureField = fields.some(
    (field) =>
      field.type === DimensionFieldType.MEASURE &&
      (field.config.dateRange === MeasureDateRange.BeginningBalance ||
        field.config.dateRange === MeasureDateRange.EndingBalance)
  );

  if (!isThereAnyMeasureField) {
    return false;
  }

  return true;
};
